import React, { useState, useEffect } from 'react';
import { ReferralLinks } from '../components/ReferralLinks';
import { useAuth } from '../context/AuthContext';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';

const AffiliatePortalPage = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState({
    totalReferrals: 0,
    pendingReferrals: 0,
    completedReferrals: 0
  });

  useEffect(() => {
    document.title = 'Affiliate Portal - Simplified Trading Journal';
  }, []);

  return (
    <div className="min-h-screen bg-transparent">
      <div className="container mx-auto py-8 px-4">
        <div className="mb-8">
          <Button 
            as={Link} 
            to="/" 
            variant="ghost" 
            className="flex items-center text-gray-700 dark:text-gray-300 hover:text-gray-950 dark:hover:text-gray-100 transition-colors"
          >
            <ArrowLeft size={18} className="mr-1" />
            Back to Home
          </Button>
        </div>
        
        <div className="mb-12 text-center">
          <h1 className="text-3xl md:text-4xl font-display font-bold mb-4 text-gray-950 dark:text-gray-100">
            Affiliate <span className="gradient-text">Portal</span>
          </h1>
          <p className="text-xl text-gray-700 dark:text-gray-300 max-w-2xl mx-auto">
            Share your referral links and earn rewards when friends subscribe.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {/* Left column: Affiliate info */}
          <div className="md:col-span-4">
            <Card className="p-6 glass-card border border-gray-200/50 dark:border-gray-600/50 bg-white/30 dark:bg-gray-800/30 backdrop-blur-[100px] rounded-xl shadow-md overflow-hidden">
              <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-gray-100">Affiliate Info</h2>
              
              <div className="space-y-4">
                <div>
                  <p className="text-sm text-gray-600 dark:text-gray-400">Email</p>
                  <p className="font-medium text-gray-900 dark:text-gray-100">{user?.email}</p>
                </div>
                
                <div>
                  <p className="text-sm text-gray-600 dark:text-gray-400">Affiliate Status</p>
                  <p className="font-medium">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300">
                      Active
                    </span>
                  </p>
                </div>
                
                <div>
                  <p className="text-sm text-gray-600 dark:text-gray-400">Commission Rate</p>
                  <p className="font-medium text-gray-900 dark:text-gray-100">40% per referral</p>
                </div>
              </div>
              
              <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-600">
                <h3 className="text-lg font-semibold mb-3 text-gray-900 dark:text-gray-100">Need Help?</h3>
                <p className="text-gray-700 dark:text-gray-300 text-sm">
                  If you have any questions about the affiliate program, please email us at{' '}
                  <a href="mailto:support@simplifiedtradingjournal.com" className="text-primary-700 dark:text-primary-400 hover:underline">
                    simplifiedtradingjournal@pm.me
                  </a>
                </p>
              </div>
            </Card>
          </div>
          
          {/* Right column: Referral links */}
          <div className="md:col-span-8">
            <ReferralLinks />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AffiliatePortalPage;